import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=5dd9bfe4&scoped=true&"
import script from "./Paginator.vue?vue&type=script&lang=ts&"
export * from "./Paginator.vue?vue&type=script&lang=ts&"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=5dd9bfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9bfe4",
  null
  
)

export default component.exports